<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 14.1">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_97" data-name="Group 97">
          <g id="Group_96" data-name="Group 96">
            <path
              id="Path_46"
              data-name="Path 46"
              class="cls-1"
              d="M12.48,14.1a14.45,14.45,0,0,1-9.3-3.63,42.67,42.67,0,0,1-3-3.13.35.35,0,0,1-.09-.49l0,0A16.85,16.85,0,0,1,9.62.33,13.22,13.22,0,0,1,19.39,1.9a17.92,17.92,0,0,1,5.46,4.83.41.41,0,0,1,0,.59l0,0a16.9,16.9,0,0,1-9.6,6.43,10.92,10.92,0,0,1-1.39.24C13.42,14.07,13,14.08,12.48,14.1Zm.07-2.27A4.79,4.79,0,1,0,7.71,7.09v.07A4.77,4.77,0,0,0,12.55,11.83Z"
            />
            <path
              id="Path_47"
              data-name="Path 47"
              class="cls-1"
              d="M12.47,4.45A2,2,0,0,0,14.1,6.73,2,2,0,0,0,15,6.67a2.29,2.29,0,0,1-.93,2.44,2.59,2.59,0,0,1-3,.13,2.6,2.6,0,0,1,1.39-4.79Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
    .cls-1 {
        fill: #0064ff;
    }
</style>
